import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/extensions/components/popup/popup.component';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SpecialOfferDeactivateGuard {
  constructor(
    private _ngbModal: NgbModal,
    private _globalService: GlobalService,
    private _router: Router
  ) {}

  async canDeactivate(component): Promise<boolean> {
    if (component.canUnloadByPassForm) {
      return true;
    }

    if ((component.form != undefined && component.form.dirty) || component.isFormDirty) {
      const modalRef = this._ngbModal.open(PopupComponent, { centered: true });
      modalRef.componentInstance.title = 'common.confirmDataLossTitle';
      modalRef.componentInstance.description = 'common.confirmDataLoss';

      try {
        const modalResult = await modalRef.result;
        if (modalResult) {
          this._globalService.pathChanged = this._router.url.split('/')[1];
        } else {
          return modalResult;
        }
      } catch (error) {
        return false;
      }
    }

    return true;
  }
}
